// extracted by mini-css-extract-plugin
module.exports = {"layout":"LoginLayout_layout__QWmXc"};